// @ts-nocheck
const originUrl = new URL(document.currentScript.src)
const targetOrigin = `${originUrl.protocol}//${originUrl.host}`

// Function to send messages to the parent window
const sendMessage = message => {
    window.parent.postMessage(message, { targetOrigin });
};

export default sendMessage;